<template>
  <div class="dicBox">
    <Form ref="searchForm" :label-width="80" :model="formCustom" inline>
      <Form-item label="字典名称：" prop="dicCode">
        <Select v-model="formCustom.dicCode" clearable filterable style="width: 200px">
          <Option v-for="item in dicList" :value="item.dicCode">{{ item.dicName }}</Option>
        </Select>
      </Form-item>
      <Form-item label="字典文本：" prop="itemText">
        <Input v-model="formCustom.itemText" :maxlength="50" clearable placeholder="请输入"
               style="width: 200px"></Input>
      </Form-item>
      <Form-item label="状态：" prop="status">
        <Select v-model="formCustom.status" clearable filterable style="width: 200px" @on-change="changeStatus">
          <Option value="0">不启用</Option>
          <Option value="1">启用</Option>
        </Select>
      </Form-item>
      <Form-item>
        <Button type="primary" @click="handleSearch">查询</Button>
        <Button class="iviewButton" @click="handleReset('searchForm')">重置</Button>
      </Form-item>
    </Form>
    <div style="margin-bottom: 20px">
      <Button v-if="btnList.includes('新增')" type="primary" @click="handleButton('add')">新增</Button>
    </div>
    <div>
      <Table :columns="dicColumns" :data="dicTableData" :loading="loading" aria-describedby="" aria-hidden="true"
             border>
        <template slot="action" slot-scope="{ row }">
          <Button v-if="btnList.includes('编辑Id')" size="small" type="text"
                  @click="handleButton('edit', row.dicItemId)">
            编辑
          </Button>
          <Button v-if="row.status === '启用' && btnList.includes('锁定')" size="small" type="text"
                  @click="lockButton('unlock', row.dicItemId)">不启用
          </Button>
          <Button v-if="row.status === '不启用' && btnList.includes('锁定')" size="small" type="text"
                  @click="lockButton('lock', row.dicItemId)">启用
          </Button>
        </template>
      </Table>
      <Page ref="pages" :current="page" :total="total" class="page_position" show-elevator show-sizer show-total
            @on-change="setCurrent" @on-page-size-change="setPage"></Page>
    </div>
  </div>
</template>

<script>
import {dicList, dicLock, dicPage} from '@/api/authority'
import permissionList from '@/libs/handlePermission.ts'

export default {
  name: 'dic',
  filters: {},
  data() {
    // 变量初始化
    return {
      total: 0,
      page: 1,
      size: 10,
      pageSize: 10,
      loading: false, // 表格等待
      lockMsg: '', // 锁定/解锁
      lockStatus: '', //锁定/解锁状态
      btnList: [],
      dicList: [],
      formCustom: {
        dicCode: '',
        itemText: '',
        status: '',
      },
      dicColumns: [
        {title: '序号', key: 'dicItemId', width: '100', align: 'center'},
        {title: '字典名称', key: 'dicName', align: 'center'},
        {title: '字典文本', key: 'itemText', align: 'center'},
        {title: '字典值', key: 'itemValue', align: 'center'},
        {title: '排序', key: 'itemOrder', width: 100, align: 'center'},
        {title: '状态', key: 'status', width: 100, align: 'center'},
        {title: '操作', slot: 'action', minWidth: 140, align: 'center', fixed: 'right'}
      ],
      dicTableData: [] // 表格数据
    }
  },
  mounted() {
    const list = JSON.parse(localStorage.getItem('routerList'))
    // eslint-disable-next-line new-cap
    this.btnList = new permissionList(list, this.$route.path).getList()
    if (this.$route.query.current !== undefined) {
      this.page = parseInt(this.$route.query.current)
      this.pageSize = parseInt(this.$route.query.size)
      if (this.$route.query.dicCode !== undefined && this.$route.query.dicCode !== '') {
        this.formCustom.dicCode = this.$route.query.dicCode;
      }
      if (this.$route.query.status !== undefined && this.$route.query.status !== '') {
        this.formCustom.status = this.$route.query.status;
      }

      this.setCurrent(this.page)
    } else {
      this.init()
    }
  },
  methods: {
    // 初始化事件
    init() {
      this.loading = true
      dicList().then((res) => {
        this.dicList = res.data.data
      })
      dicPage({
        current: 1,
        size: 10,
        dicCode: this.formCustom.dicCode,
        itemText: this.formCustom.itemText,
        status: this.formCustom.status
      }).then((res) => {
        this.changeData(res)
        this.$refs['pages'].currentPage = 1 // 分页变成第一页
      })
    },
    // 调接口获取表格数据
    changeData(res) {
      this.total = res.data.data.total
      this.size = res.data.data.size
      this.dicTableData = res.data.data.records
      res.data.data.records.forEach((element, index) => {
        if (element.status === 0) {
          this.dicTableData[index].status = '不启用'
        } else if (element.status === 1) {
          this.dicTableData[index].status = '启用'
        }
      })
      this.loading = false
    },
    // 查询
    handleSearch() {
      dicPage({
        current: 1,
        size: this.pageSize,
        dicCode: this.formCustom.dicCode,
        itemText: this.formCustom.itemText,
        status: this.formCustom.status
      }).then((res) => {
        this.changeData(res)
        this.$refs['pages'].currentPage = 1 // 分页变成第一页
      })
    },
    // 重置
    handleReset(name) {
      this.$refs[name].resetFields()
      // 重置查询条件会再次查询
      this.handleSearch()
    },
    changeStatus(val) {
      this.formCustom.status = val;
    },
    // 新增/编辑跳转
    handleButton(val, id) {
      switch (val) {
        case 'add':
          this.$router.push(
            {
              path: '/authority/dic/dicAdd',
              query: {
                current: this.page,
                size: this.pageSize,
                dicCode: this.formCustom.dicCode,
                itemText: this.formCustom.itemText,
                status: this.formCustom.status
              }
            }
          )
          break
        case 'edit':
          this.$router.push(
            {
              path: '/authority/dic/dicEdit',
              query: {
                dicItemId: id,
                current: this.page,
                size: this.pageSize,
                dicCode: this.formCustom.dicCode
              }
            }
          )
          break
        default:
          break
      }
    },
    // 改变页码
    setCurrent(val) {
      this.loading = true
      this.page = val
      dicPage({
        current: val,
        size: this.pageSize,
        dicCode: this.formCustom.dicCode,
        itemText: this.formCustom.itemText,
        status: this.formCustom.status
      }).then((res) => {
        this.changeData(res)
      })
    },
    // 改变每页条数
    setPage(val) {
      this.loading = true
      this.pageSize = val
      dicPage({
        current: 1,
        size: this.pageSize,
        dicCode: this.formCustom.dicCode,
        itemText: this.formCustom.itemText,
        status: this.formCustom.status
      }).then((res) => {
        this.changeData(res)
        this.$refs['pages'].currentPage = 1 // 分页变成第一页
      })
    },
    // 启用/不启用
    lockButton(val, id) {
      if (val === 'lock') {
        this.lockMsg = '确认启用？'
        this.lockStatus = 1
      } else if (val === 'unlock') {
        this.lockMsg = '确认不启用？'
        this.lockStatus = 0
      }
      this.$Modal.confirm({
        title: this.lockMsg,
        onOk: () => {
          dicLock({
            dicItemId: id,
            status: this.lockStatus
          }).then((res) => {
            this.$Message.success(res.data.msg)
            this.init()
          }).catch(() => {
            if (val === 'lock') {
              this.$Message.error('启用失败')
            } else if (val === 'unlock') {
              this.$Message.error('不启用失败')
            }
          })
        },
        onCancel: () => {
          if (val === 'lock') {
            this.$Message.info('已取消启用')
          } else if (val === 'unlock') {
            this.$Message.info('已取消不启用')
          }
        }
      })
    },
  }
}
</script>
